<div class="close-button" (click)="closeDialog()"></div>
<div class="scrollable">

  <div class="top-info">
    <img loading="lazy" [style.marginLeft]="alreadyVoted ? '23px' : '0'" src="/assets/icons/{{alreadyVoted ? 'colibri-green' : 'give-five'}}.svg" alt="image">
    <div class="congrat">{{ (alreadyVoted ? "ALREADY_VOTED.bravo_alreadyvoted" : "VOTES_COMPLETED.good_votescompleted") | translate }}</div>
    <div class="message">{{ (alreadyVoted ? "ALREADY_VOTED.subtitle_alreadyvoted" : "VOTES_COMPLETED.subtitle_votescompleted") | translate }}</div>
    <div class="share" appTooltip></div>
    <div class="buttons-container" *ngIf="hasSubs">
        <button class="donate-button impact" (click)="gotoImpactPage()">
          <span>{{ "VOTES_COMPLETED.see_impact_votescompleted" | translate }}</span>
        </button>
    </div>
  </div>
  <div class="bottom-info" *ngIf="!hasSubs">
    <div class="more-impact">{{ "VOTES_COMPLETED.more_votescompleted" | translate }}</div>
    <div class="buttons-container">
        <button class="green sans-serif donate-button" (click)="openOneTimeDonation()">
          <span class="bird-custom"><img loading="lazy" src="/assets/icons/colibri-very-dark-grey.svg" alt="bird"></span>
          <span>{{ "VOTES_COMPLETED.donation_votescompleted" | translate }}</span>
        </button>
    </div>
  </div>
</div>


